module.exports = require("inversify");